module.exports = __webpack_public_path__ + "static/media/clickclick_iphone.44bf2d5d.png";